<div class="header-main">
  <core-title-section [title]="title" [breadcrumbs]="breadcrumbs"></core-title-section>
  <div [hidden]="edit" class="labels-edit-container"><core-labels-text [labels]="project.labels"></core-labels-text></div>
  <core-helpers-navigation-three-dots-menu [menu]="menu" (action)="onMenuSelect($event)"></core-helpers-navigation-three-dots-menu>
</div>
